import styled from '@emotion/styled';
import { PreviewType } from '../../CreatePage/types';

export const Card = styled.div<{ preview?: PreviewType }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    padding: 25px 72px;
    border-radius: 20px;
    max-width: 840px;
    width: 100%;

    @media (max-width: '768px'), ${({ preview }) => preview === PreviewType.MOBILE && 'screen'} {
        width: 100%;
        height: 100%;
        padding: 0;
        padding-block-start: 40px;
        padding-inline: 10px;
    }

    @media ${({ preview }) => preview && 'screen'} {
        ${({ preview }) =>
            preview === PreviewType.MOBILE &&
            `
            width: 375px;
            height: 812px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;`}

        ${({ preview }) => preview === PreviewType.DESKTOP && 'width: 656px;'}
    }
`;
